module.exports = __webpack_public_path__ + "img/rapid-transfer.f23bc47e.svg";